import React from 'react';
import PropTypes from 'prop-types';
import { Map, TileLayer, GeoJSON, Rectangle } from 'react-leaflet';
import './InsetMap.css'

const InsetMap = ({ perimeter, bounds }) => {
  return (
    <Map
      id='inset_map'
      zoom={15}
      center={[37.53668110395066,-77.38776039797814]}
      maxZoom={24}
      minZoom={13}
      zoomControl={false}
      attributionControl={false}
    >
      <TileLayer 
        url='//s3.amazonaws.com/dsl-general/eastend2020/{z}/{x}/{y}.png' 
        maxNativeZoom={ 25 }
        maxZoom={ 25 }
        detectRetina={ true }
      />

      <GeoJSON
        data={perimeter}
        color='silver'
        weight={0.5}
        fillColor='silver'
        fillOpacity={1}
        className='perimeter'
      />

      <Rectangle
        bounds={bounds}
        color='#262626'
        weight={2}
      />
    </Map>
  );
};

export default InsetMap;

InsetMap.propTypes = {
  bounds: PropTypes.arrayOf(PropTypes.array),
  perimeter: PropTypes.object,
};

InsetMap.defaultProps = {
  
};



// WEBPACK FOOTER //
// ./src/components/InsetMap.jsx